<div class="container">
  <div class="message">
    <p>ファイルをダウンロードしています。</p>
    <p>しばらくお待ちください。</p>
  </div>
</div>
